import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DefaultSelectField } from 'src/components/mui-overrides/SelectTextField';
import { useAssetType } from '../../../context-providers/asset-type/AssetTypeContext';
import { useFormikContext } from 'formik';

interface Props {
  disabled?: boolean;
}

export const PowerPlantBusinessTypeSelector: FC<Props> = ({ disabled }) => {
  const { t } = useTranslation();
  const { assetType } = useAssetType();
  const formik = useFormikContext();

  if (assetType !== 'powerplantPortfolio') {
    return null;
  }
  const options = [
    {
      value: 'private',
      label: t('general.powerplantBusiness.private'),
    },
    {
      value: 'business',
      label: t('general.powerplantBusiness.business'),
    },
  ];
  return (
    <>
      <DefaultSelectField
        disabled={disabled}
        formik={formik}
        label={t('dashboard.assets.addedit.main.generalinfo.fields.powerplantBusiness.label')}
        fieldName="propertyDetails.powerplantbusinessType"
        options={options}
      />
    </>
  );
};
